import React from 'react';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { selectFilteredInspectionPlans, selectInspectionPlanLoading } from './store/selectors';
import { showModal } from 'Core/redux/main/slice';
import { deleteInspectionPlan } from './store/slice';
import { MODAL_TYPES } from 'Feature/components/app-modals';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';

const { INSPECTIONPLAN_ADD_EDIT } = MODAL_TYPES;

const InspectionPlanTable = () => {
  const dispatch = useDispatch();
  const { filteredData, isLoading } = useSelector(state => ({
    filteredData: selectFilteredInspectionPlans(state),
    isLoading: selectInspectionPlanLoading(state),
  }));

  const handleEditClick = record => {
    dispatch(showModal(INSPECTIONPLAN_ADD_EDIT, record));
  };

  const handleDeleteClick = id => {
    dispatch(deleteInspectionPlan(id));
  };

  const handleCheckboxChange = (e, record) => {
    // Handle checkbox change logic here
    console.log('Checkbox changed', record, e.target.checked);
  };

  const columns = [    
    {
      title: 'PartNumber',
      dataIndex: 'partName',
      sorter: (a, b) => a.partName.length - b.partName.length,
    },
    {
      title: 'Inspection Plan',
      dataIndex: 'inspectionPlan',
      sorter: (a, b) => a.inspectionPlan.length - b.inspectionPlan.length,
    },
    {
      title: 'Created Date',
      dataIndex: 'createdDate',
      sorter: (a, b) => a.createdDate.length - b.createdDate.length,
    }, 
    {
      title: 'Actions',
      dataIndex: 'inspectionPlanId',
      key: 'id',
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link className="me-2 p-2" onClick={() => handleEditClick(record)}>
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link className="confirm-text p-2" onClick={() => handleDeleteClick(record.inspectionPlanId)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className="table-responsive product-list">
      {isLoading && <LoadingSpinner />}
      <Table columns={columns} dataSource={filteredData} />
    </div>
  );
};

export default InspectionPlanTable;
